import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=1987dd89&scoped=true"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=1987dd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987dd89",
  null
  
)

/* custom blocks */
import block0 from "./BankDetailsForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports